
import { defineComponent, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import IoHeader from '@/components/IoHeader.vue';
import IoFooter from '@/components/IoFooter.vue';
import ProgressBar from '@/components/partials/ProgressBar.vue';

export default defineComponent({
  components: {
    IoHeader,
    IoFooter,
    ProgressBar,
  },

  setup() {
    const store = useStore();
    const isLoading = computed(() => store.getters.status === 1);
    const loaderStyle = computed<string>(() => {
      const percentage = isLoading.value ? 0 : 100;

      return `width:${percentage}px`;
    });

    onBeforeMount(() => {
      store.dispatch('districtOffices/fetchAll');
      store.dispatch('contactPersons/fetchAll');
      store.dispatch('partners/fetchAll');
      store.dispatch('events/fetchAll');
    });

    return {
      isLoading,
      loaderStyle,
    };
  },
});
